import { createSuggestion as createSuggestionAction } from '../../../../actions/suggestions/suggestions'
import { validateData } from './validate-data'
import { formatData } from './format-data'
import { handleResponse } from './handle-response'
import { handleError } from './handle-error'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Yeni bir öneri oluşturur
 * @param {Object} suggestionData - Öneri verileri
 * @returns {Promise<Object>} Oluşturulan öneri
 */
export const createSuggestion = async (suggestionData) => {
  try {
    // Öneri verilerini doğrula
    const { isValid, formattedErrorMessage } = validateData(suggestionData)
    if (!isValid) {
      responseHandlerService.handleError(null, formattedErrorMessage)
      return {
        success: false,
        message: formattedErrorMessage,
        data: null,
      }
    }

    // API'ye göndermek için verileri formatla
    const formattedData = formatData(suggestionData)

    // API çağrısını yap
    const response = await createSuggestionAction(formattedData)

    // Yanıtı işle
    return handleResponse(response)
  } catch (error) {
    return handleError(error)
  }
}

export {
  validateData,
  formatData,
  handleResponse,
  handleError,
}